/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable new-cap */
/*
 * Author M. Atoar Rahman
 * Title: Drug DataTable
 * Description: Drug DataTable
 * Date: 26/04/2022
 */

import JsBarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import Barcode from 'react-barcode';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import useDataTable from '../../../hooks/useDataTable';
import SweetAlertService from '../../../services/SweetAlertService';
import UrlService from '../../../services/UrlService';
import { useDrug } from './ContextAPI';

export default function DataTable() {
    const { data, getAllData, setShow, setRowData, setIsSubmitted } = useDrug();
    const { deleteSwal } = SweetAlertService();
    const printRef = useRef(null);

    const dataList = useCallback(() => {
        getAllData();
        setRowData('');
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const editHander = (row) => {
        setShow(true);
        setRowData(row);
        setIsSubmitted(false);
    };

    const deleteHandler = (row) => {
        deleteSwal({
            id: row.drug_id,
            url: UrlService.deleteDrugUrl(),
            refreshList: getAllData,
            beforeTitle: 'Are you sure?',
            beforeText: "You won't be able to revert this!",
            afterTitle: 'Deleted!',
            afterText: 'Your file has been deleted.',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
    };

    const columns = [
        {
            name: 'SL',
            selector: (row, index) => index + 1,
            sortable: true,
            width: '40px',
        },
        {
            name: 'UID',
            selector: (row) => row.code_no,
            sortable: true,
        },
        {
            name: 'Barcode',
            selector: (row) => row.code_no,
            cell: (row) => (
                <Barcode height="30" displayValue value={row.code_no} format="CODE128" />
            ),
        },
        {
            name: 'Generic Name',
            selector: (row) => row.generic_name,
            sortable: true,
            grow: 3,
        },
        {
            name: 'Administration Route',
            selector: (row) => row.group_name,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Category',
            selector: (row) => row.category_name,
            sortable: true,
        },
        {
            name: 'Presentation Strength',
            selector: (row) => row.strength_name,
            sortable: true,
        },
        {
            name: 'Presentation Type',
            selector: (row) => row.ptype,
            sortable: true,
        },
        {
            name: 'Created Date',
            selector: (row) => moment(row.created_at).format('Do MMM YYYY'),
            sortable: true,
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <>
                    {/* <Button data-id={row.id} type="button" className="btn btn-light actionBtn">
                        {layout}
                    </Button> */}

                    {/* <FormInfo editData={row} /> */}

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-${row.drug_id}`}>Edit</Tooltip>}
                    >
                        <Button
                            className="btn btn-light actionBtn"
                            variant="primary"
                            onClick={() => editHander(row)}
                        >
                            <i className="fas fa-edit" />
                        </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-del-${row.drug_id}`}>Delete</Tooltip>}
                    >
                        <Button
                            onClick={() => {
                                deleteHandler(row);
                            }}
                            type="button"
                            className="btn btn-light actionBtn"
                        >
                            <i className="fas fa-trash-alt" />
                        </Button>
                    </OverlayTrigger>
                </>
            ),
        },
    ];

    const search_column = {
        code_no: 'UID',
        generic_name: 'Generic Name',
        group_name: 'Administration Route',
        category_name: 'Category',
        strength_name: 'Presentation Strength',
        ptype: 'Presentation Type',
    };

    const printableRows = useMemo(
        () =>
            (data || []).map((row, index) => ({
                SL: index + 1,
                UID: row.code_no,
                Barcode: row.code_no,
                'Generic Name': row.generic_name,
                'Administration Route': row.group_name,
                Category: row.category_name,
                'Presentation Strength': row.strength_name,
                'Presentation Type': row.ptype,
                'Created Date': moment(row.created_at).format('Do MMM YYYY'),
            })),
        [data]
    );

    const printColumns = useMemo(
        () => Object.keys(printableRows[0] || {}),
        [printableRows]
    );

    const handleExcelExport = () => {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(printableRows);
        XLSX.utils.book_append_sheet(wb, ws, 'DrugInformation');
        XLSX.writeFile(wb, 'DrugInformation.xlsx');
    };

    const handlePdfExport = () => {
        if (!printableRows || printableRows.length === 0) {
            // nothing to export
            return;
        }
        // Generate barcode images as data URLs for each row (client-side)
        const barcodeDataUrls = (printableRows || []).map((r) => {
            try {
                const canvas = document.createElement('canvas');
                // JsBarcode can render to canvas
                JsBarcode(canvas, String(r.UID || r.UID === 0 ? r.UID : ''), {
                    format: 'CODE128',
                    displayValue: false,
                    height: 40,
                    width: 1.5,
                });
                return canvas.toDataURL('image/png');
            } catch (e) {
                return null;
            }
        });

        // eslint-disable-next-line new-cap
        const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
        const pdfColumns = printColumns;
        const body = printableRows.map((r) => pdfColumns.map((c) => (c === 'Barcode' ? '' : (r[c] !== undefined && r[c] !== null ? String(r[c]) : ''))));

        doc.setFontSize(14);
        doc.text('Drug Information', 40, 40);

        // autoTable will place the table below the title and we will draw barcode images in didDrawCell
        // @ts-ignore
        doc.autoTable({
            head: [pdfColumns],
            body,
            startY: 60,
            styles: { fontSize: 9 },
            headStyles: { fillColor: [41, 128, 185] },
            theme: 'grid',
            margin: { left: 40, right: 40 },
            didDrawCell(cellData) {
                // draw barcode image into the Barcode column cells
                const barcodeColIndex = pdfColumns.indexOf('Barcode');
                if (cellData.section === 'body' && cellData.column.index === barcodeColIndex) {
                    const rowIndex = cellData.row.index;
                    const imgData = barcodeDataUrls[rowIndex];
                    if (imgData) {
                        const { cell } = cellData;
                        const { width: cellWidth, height: cellHeight, x: cellX, y: cellY } = cell;
                        const imgWidth = Math.min(cellWidth - 6, 120);
                        const imgHeight = Math.min(cellHeight - 6, 40);
                        const imgX = cellX + (cellWidth - imgWidth) / 2;
                        const imgY = cellY + (cellHeight - imgHeight) / 2;
                        try {
                            doc.addImage(imgData, 'PNG', imgX, imgY, imgWidth, imgHeight);
                        } catch (err) {
                            // ignore image drawing errors
                        }
                    }
                }
            },
        });

        // add page numbers
        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i += 1) {
            doc.setPage(i);
            doc.setFontSize(9);
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.text(`Page ${i} of ${pageCount}`, pageWidth - 100, pageHeight - 30);
        }

        doc.save('DrugInformation.pdf');
    };

    return (
        <div>
            <div className="mb-3 d-flex gap-2 justify-content-end">
                <OverlayTrigger placement="top" overlay={<Tooltip id="tip-excel">Download Excel</Tooltip>}>
                    <Button className="btn btn-light" onClick={handleExcelExport}>
                        <i className="fas fa-file-excel" /> Excel
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tip-pdf">Download PDF</Tooltip>}>
                    <Button className="btn btn-light" onClick={handlePdfExport}>
                        <i className="fas fa-file-pdf" /> PDF
                    </Button>
                </OverlayTrigger>
            </div>

            {useDataTable({ columns, data, search_column })}

            <div style={{ position: 'absolute', left: '-10000px', top: 0 }}>
                <div ref={printRef} aria-hidden>
                    <h3 style={{ textAlign: 'center', marginBottom: 12 }}>Drug Information</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                {printColumns.map((col) => (
                                    <th key={col} style={{ border: '1px solid #000', padding: '6px', textAlign: 'left' }}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {printableRows.map((r) => (
                                <tr key={r.UID}>
                                    {printColumns.map((col) => (
                                        <td key={`${r.UID}-${col}`} style={{ border: '1px solid #000', padding: '6px' }}>{r[col]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
